
	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Account } from '@shared/models';

	@Component({})
	export default class AccountList extends BaseView {

		@Prop({ type: Array as PropType<Account[]> })
		public list: Account[];

	}

